module.exports = __webpack_public_path__ + "img/3DSProjectCCIToCIA.039848c6.jpg";